<div ngbDropdown>
    <button ngbDropdownToggle
        id="dropdownBasic"
        placement="placement"
        autoClose="autoClose"
        open="open"
        class="dropdown-btn-weight"
        dropdownClass="dropdownClass"
        [ngClass]="dropdownBtnClass"
        [disabled]="disabled">
        {{ placeholder }}
    </button>

    <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <li *ngFor="let item of listItems; trackByProperty"
                class="p-0">
                <button *ngIf="!item.isDivider && item.visible"
                    class="ps-2"
                    [disabled]="item.disabled"
                    [ngClass]="item.class"
                    (click)="item.clickFn()"
                    ngbDropdownItem>
                    {{item.label}}
                </button>

                <div class="dropdown-divider p-o"
                    *ngIf="item.isDivider">
                </div>
            </li>
    </div>
</div>
